import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const backgroundImage = 'https://static.readdy.ai/image/266bb3bc7ccfcec14fddb7759900fdba/d47b60b84d69de079e03f2557246aa7f.jpeg';

  return (
    <section className="relative h-[600px] flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundImage}')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full px-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-white font-serif text-6xl font-bold mb-6 tracking-wide" style={{ writingMode: 'vertical-rl', height: '400px' }}>
              祈祷のご予約
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-right"
          >
            <p className="text-white text-lg mb-8 leading-relaxed">
              家内安全、商売繁盛、学業成就など<br />
              各種ご祈祷を承っております
            </p>
            <Link 
              to="/prayer-reservation"
              className="inline-flex items-center gap-4 bg-[#D4AF37] text-black px-8 py-4 rounded-full hover:bg-[#C4A037] transition-all group cursor-pointer whitespace-nowrap"
            >
              <span className="font-semibold tracking-wide text-lg">予約する</span>
              <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
